import { API } from "aws-amplify";

export const GET_SALES_REPORT_LIST_REQUEST =
  "@@report/GET_SALES_REPORT_LIST_REQUEST";
export const GET_SALES_REPORT_LIST_SUCCESS =
  "@@report/GET_SALES_REPORT_LIST_SUCCESS";
export const GET_SALES_REPORT_LIST_FAILURE =
  "@@report/GET_SALES_REPORT_LIST_FAILURE";

export function getSalesReportList() {
  return async (dispatch) => {
    dispatch({
      type: GET_SALES_REPORT_LIST_REQUEST,
    });
    try {
      let url = "/report/sales";
      const response = await API.get("cmsAPI", url);
      dispatch({
        type: GET_SALES_REPORT_LIST_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_SALES_REPORT_LIST_FAILURE,
        payload: error,
      });
    }
  };
}
